/* eslint-disable react/require-default-props */
import React from 'react';
import { ListDrop } from './styles';

interface Props {
  name: string;
  onPress?: Function;
}

const ItemListDrop: React.FC<Props> = ({ name, onPress }) => (
  <ListDrop onClick={() => onPress && onPress()}>{name}</ListDrop>
);
export default ItemListDrop;
